/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { RequestBuilder } from '../../request-builder';
import { StrictHttpResponse } from '../../strict-http-response';

import { ReservedMarkTransferReviewResultDto } from '../../models/reserved-mark-transfer-review-result-dto';
import { ReviewReservedMarkTransferRequestBodyDto } from '../../models/review-reserved-mark-transfer-request-body-dto';

export interface ApproveReservedMarkTransferRequestForUser$Params {
  body: ReviewReservedMarkTransferRequestBodyDto;
}

export function approveReservedMarkTransferRequestForUser(
  http: HttpClient,
  rootUrl: string,
  params: ApproveReservedMarkTransferRequestForUser$Params,
  context?: HttpContext,
): Observable<StrictHttpResponse<ReservedMarkTransferReviewResultDto>> {
  const rb = new RequestBuilder(
    rootUrl,
    approveReservedMarkTransferRequestForUser.PATH,
    'put',
  );
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http
    .request(
      rb.build({ responseType: 'json', accept: 'application/json', context }),
    )
    .pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<ReservedMarkTransferReviewResultDto>;
      }),
    );
}

approveReservedMarkTransferRequestForUser.PATH =
  '/me/surveyMarks/reserved/transfer-request/approve';
